<ng-template #modal let-dismiss="dismiss">
  <div class="modal-header">
    <h5 class="modal-title">Already discussed?</h5>
    <button type="button" class="close" aria-label="Close" (click)="dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>If you have already covered these topics during an appointment, you can mark it as completed.</p>
  </div>

  <div class="modal-footer">
    <button (click)="dismiss()" class="btn btn-alternate">Cancel</button>
    <button (click)="complete()" class="btn btn-primary">Complete</button>
  </div>
</ng-template>
